import { css } from 'styled-system/css';

export const btnStyle = css.raw({
  w: 'full',
  h: 'full',
  p: '16px',
});
